export interface DocumentCompletedInterface {
    id: number;
    documentId: number;
    documentTitle: string;
    userId: number;
    points?: number;  // The '?' indicates that the property is optional
    dateAndTime: Date;
    submissionText?: string;  // Optional property
}

export class DocumentCompleted implements DocumentCompletedInterface {
    public id: number;
    public documentId: number;
    public documentTitle: string;
    public userId: number;
    public points?: number;
    public dateAndTime: Date;
    public submissionText?: string;

    // Constructor to initialize properties
    constructor(
        id: number,
        documentId: number,
        documentTitle: string,
        userId: number,
        dateAndTime: Date,
        points?: number,
        submissionText?: string
    ) {
        this.id = id;
        this.documentId = documentId;
        this.documentTitle = documentTitle
        this.userId = userId;
        this.points = points;
        this.dateAndTime = dateAndTime;
        this.submissionText = submissionText;
    }

    static fromJson(json: any): DocumentCompleted {
        return new DocumentCompleted(
            json.id,
            json.documentId,
            json.documentTitle,
            json.userId,
            json.dateAndTime ? new Date(json.dateAndTime) : new Date(),
            json.points,
            json.submissionText
        );
    }

    static fromJsonArray(jsonArray: any[]): DocumentCompleted[] {
        return jsonArray.map(item => DocumentCompleted.fromJson(item));
    }
}
